module.exports = __webpack_public_path__ + "static/monikawork2-f31730521ac381c4082617fa08387785.jpg";